// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)

// Import specific channels
import "./salesforce_refresh_channel"
import "./salesforce_shipto_sync_channel"
import "./fulfillment_channel"
